import { OrganizationStage } from 'entities-next/fundingRounds'
import {
  organizationStageToOrganizationStageLabel,
  OrganizationStageToStageLabels,
  organtizationStageLabelTorganizationStage,
} from 'entities-next/search-engine/stage.utils'
import { isArray } from 'lodash'
import React, { useCallback } from 'react'
import { AutoCompleteFormik, AutoCompleteProps } from 'scenes/Dashboard/components/Inputs/Select'
import {
  AutoCompleteDataType,
  AutoCompleteOption,
} from 'scenes/Dashboard/components/Inputs/Select/AutoComplete/AutoComplete.model'
import { FieldProps } from 'utils-next/forms'

const organizationStagesOptions: {
  display: {
    label: string
  }
  value: string
}[] = []

Object.keys(OrganizationStageToStageLabels).map((key) => {
  organizationStagesOptions.push({
    display: {
      label: OrganizationStageToStageLabels[key],
    },
    value: key,
  })
})

export type StageSelectProps = Omit<AutoCompleteProps, 'value' | 'dataType' | 'onCreateOption' | 'onChange'> &
  FieldProps
export function StageSelect({
  field: { name, value },
  form: { setFieldValue },
  isMulti,
  ...asyncSelectProps
}: StageSelectProps) {
  const handleChange = useCallback(
    (autoCompleteOption: AutoCompleteOption | '') => {
      if (!autoCompleteOption) {
        setFieldValue('includeCompaniesWithoutMaturityInformation', true)
        setFieldValue(name, undefined)
        return
      }
      if (isArray(autoCompleteOption)) {
        const values = autoCompleteOption.map((option) => {
          if (option.value.name) {
            return organtizationStageLabelTorganizationStage(option.value.name)
          }
          return organtizationStageLabelTorganizationStage(option.value)
        })
        setFieldValue(`${name}.stages`, values)
      }
    },
    [name, setFieldValue]
  )

  const parsedValues = value
    ? value.stages.map((stage: OrganizationStage) =>
        stage ? { value: stage, display: { label: organizationStageToOrganizationStageLabel(stage) } } : undefined
      )
    : undefined

  const parsedValue = value
    ? { value: value, display: { label: organizationStageToOrganizationStageLabel(value) } }
    : undefined

  return (
    <AutoCompleteFormik
      dataType={AutoCompleteDataType.stage}
      onChange={handleChange}
      loadOptions={async (value) => {
        return organizationStagesOptions.filter((option) =>
          option.display.label.toLowerCase().includes(value.toLowerCase())
        )
      }}
      isMulti={isMulti}
      value={isMulti ? parsedValues : parsedValue}
      isClearable
      name={name}
      placeholder={'Serie A, Seed...'}
      {...asyncSelectProps}
    />
  )
}
